import { Base } from '../base-component';

import './article-combo-large-images.component.scss';

export class ArticleComboLargeImages extends Base {

	init() {}

	bindEvents() {}
}


// WEBPACK FOOTER //
// ./components/article-combo-large-images/article-combo-large-images.component.ts